import { useRouter } from 'next/router';

const useModifiedPath = () => {
  const router = useRouter();

  const getModifiedPath = () => {
    const routerClone = JSON.parse(JSON.stringify(router));
    const updatedPath = routerClone?.pathname?.replace('/[region]-[lang]', '');
    routerClone.pathname = updatedPath;
    return routerClone;
  };

  return getModifiedPath;
};

export default useModifiedPath;
